import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from 'tss-react/mui';
import { styled } from '@mui/material/styles';
import MuiTable from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Typography from '@mui/material/Typography';
import Toolbar from '@mui/material/Toolbar';

import Spinner from '../spinner';

import { utils } from '../../utils/utils';

const useStyles = makeStyles()(theme => ({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: 440,
    },
    noContent: {
        marginTop: theme.spacing(1)
    }
}));


const StyledTableRow =  styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    }
}));


const Table = ({ title, rows, columns, page, rowsPerPage, actions, noContentText, loading, loadingText }) => {
    const { classes } = useStyles();
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('');

    const handleChangeSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    return (
        <>
            {   title && 
                <Toolbar>
                    <Typography className={classes.title} variant="h6" id="tableTitle" component="div">
                        {title}
                    </Typography>
                </Toolbar>
            }
            <TableContainer className={classes.container}>
                <MuiTable stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {
                                columns.map(column =>
                                    <TableCell
                                        key={column.id}
                                        align={column.align || 'left'}
                                    >
                                        {
                                            !column.sort
                                                ? <div>{column.label}</div>
                                                : <TableSortLabel
                                                    active={column.id === orderBy}
                                                    direction={order}
                                                    onClick={(e) => handleChangeSort(e, column.id)}
                                                  >
                                                    {column.label}
                                                </TableSortLabel>
                                        }
                                    </TableCell>
                                )
                            }
                            {
                                actions &&
                                <TableCell align='right'>Acciones</TableCell>
                            }
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {                        
                            !loading &&
                            utils
                                .stableSort(rows, orderBy, order)
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row, index) =>
                                    <StyledTableRow key={index} role="checkbox" tabIndex={-1}>
                                        {
                                            columns.map((column, i) => {
                                                return (
                                                    typeof (column.id) !== "object"
                                                        ? <TableCell
                                                            key={column.id}
                                                            align={column.align || 'left'}
                                                          >
                                                            {row[column.id]}
                                                        </TableCell>
                                                        :                                                        <TableCell
                                                            key={column.id}
                                                            align={column.align || 'left'}
                                                                                                                 >
                                                            {row[column.id.key1] !== null && row[column.id.key1][column.id.key2]}
                                                        </TableCell>
                                                )
                                            })
                                        }
                                        {
                                            actions &&
                                            <TableCell align='right'>
                                                {actions(row)}
                                            </TableCell>
                                        }
                                    </StyledTableRow>
                                )
                        }
                    </TableBody>
                </MuiTable>
                {
                    loading &&
                    <div className={classes.noContent}>
                        <Typography align='center' variant='h6'>
                            {loadingText}
                        </Typography>
                        <Spinner />
                    </div>
                }
                {
                    !loading &&
                    rows.length === 0 &&
                    <div className={classes.noContent}>
                        <Typography align='center' variant='h6'>
                            {noContentText}
                        </Typography>
                    </div>
                }
            </TableContainer>
        </>
    )
}

Table.defaultProps = {
    rows: [],
    columns: [],
    page: 0,
    rowsPerPage: 999999999,
    noContentText: "No se encontraron resultados",
    loadingText: "Buscando"
}

Table.prototype = {
    actions: PropTypes.func,
    rows: PropTypes.arrayOf(PropTypes.object),
    columns: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        align: PropTypes.string,
        sort: PropTypes.bool
    })),
    page: PropTypes.number,
    rowsPerPage: PropTypes.number,
    noContentText: PropTypes.string,
    loadingText: PropTypes.string
}

export default Table;